<template>
  <div class="collegeIcon">
    <div class="college-list">
      <div
        class="college-item"
        :xs="6"
        :sm="6"
        :md="6"
        v-for="(item, index) in collegeList"
        :key="index"
        @click="handleClick(item)"
      >
        <img class="college-item-icon" :src="item.collegeIconUrl" />
        <span class="college-item-name">{{ item.collegeName }}</span>
        <span class="college-item-note">学院</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { getCollege } from "@/api/home.js"
  export default {
    data() {
      return {
        collegeList: [],
        limitCollegeList: [],
        phoneCollegeList: [],
        viewportWidth: window.outerWidth
      }
    },
    created() {
      this.handleQuery()
    },
    methods: {
      handleQuery() {
        getCollege()
          .then((res) => {
            this.collegeList = res.data.data
            this.collegeList = this.$tool.sortByIndex(this.collegeList)
            this.limitCollegeList = this.collegeList.slice(0, 11)
            this.phoneCollegeList = this.collegeList.slice(0, 7)
            this.phoneCollegeList.push({
              collegeName: "更多",
              collegeIconUrl: require("@/assets/images/phone/icon_more.png")
            })
          })
          .catch((err) => {})
      },
      handleClick(item) {
        if (item.collegeName === "更多") {
          this.$refs.fixed_bg.style.display = "block"
        } else {
          this.$router.push({
            path: "/subcollege",
            query: {
              name: item.collegeName,
              id: item.id
            }
          })
          this.$store.commit("SET_ACTIVE_MENU", {
            activeParentMenu: "九大核心院系",
            activeMenu: item.collegeName
          })
        }
      },
      //关闭弹窗
      handleClose() {
        this.$refs.fixed_bg.style.display = "none"
      }
    }
  }
</script>

<style scoped lang="scss">
  // ≥1920px
  .collegeIcon {
    padding: 34px 0;
  }

  .college-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .college-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      height: 100px;
      cursor: pointer;
      .college-item-icon {
      }
      .college-item-name {
        margin-top: 10px;
        color: #292929;
        font-size: 12px;
        text-align: center;
      }
      .college-item-note {
        margin-top: 7px;
        color: #939393;
        font-size: 10px;
      }
    }
  }

  // <768px
  @media (max-width: 768px) {
    .college-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      .college-item {
        .college-item-icon {
          width: 55px;
          height: 55px;
        }
        .college-item-name {
          margin-top: 5px;
        }
        .college-item-note {
          margin-top: 5px;
        }
      }
    }
  }

  // ≥768px
  @media (min-width: 768px) {
    .college-list {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 10px;
      .college-item {
        .college-item-icon {
          width: 55px;
          height: 55px;
        }
        .college-item-name {
          margin-top: 5px;
        }
        .college-item-note {
          margin-top: 5px;
        }
      }
    }
  }

  // ≥1200px
  @media (min-width: 1200px) {
    .collegeIcon {
      background-color: #eaf2ff;
    }

    .college-list {
      max-width: 1440px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      // grid-template-columns: repeat(11, 1fr);

      .college-item {
        height: 210px;
        .college-item-icon {
          width: 104px;
          height: 104px;
        }
        .college-item-name {
          font-size: 18px;
        }
        .college-item-note {
          font-size: 16px;
        }
      }
    }
  }
</style>
